import { useCompanyCodes, useTenantsName } from "@/api/master-param";
import { useProfile } from "@/api/profile";
import { useUsers } from "@/api/user";
import { ROLE } from "@/utils/constant";

export function useFormOptions() {
  const { data: companyCodes } = useCompanyCodes();
  const { data: tenantsName } = useTenantsName();
  const { data: currentProfile } = useProfile();
  const { data: users } = useUsers({
    limit: "1000",
  });

  const picLinknetOptions = users?.content.reduce(
    (acc, user) => {
      if (user.role === ROLE.VALIDATOR_DOCUMENT_OFFICER) {
        acc.push({ label: user.username, value: user.id });
      }
      return acc;
    },
    [] as { label: string; value: string }[],
  );
  const picVendorOptions = users?.content.reduce(
    (acc, user) => {
      if (user.role !== ROLE.VENDOR) {
        return acc;
      }

      if (currentProfile?.role === ROLE.VENDOR) {
        if (user.companyCode === currentProfile.companyCode) {
          acc.push({ label: user.username, value: user.id });
        }
        return acc;
      }

      acc.push({ label: user.username, value: user.id });
      return acc;
    },
    [] as { label: string; value: string }[],
  );
  const vendorNameOptions =
    companyCodes?.content?.map((code) => ({
      label: code.value,
      value: code.paramTag,
    })) || [];
  const tenantsNameOptions =
    tenantsName?.content?.map((tenant) => ({
      label: tenant.value,
      value: tenant.value,
    })) || [];

  return {
    picLinknetOptions,
    picVendorOptions,
    vendorNameOptions,
    tenantsNameOptions,
  };
}
